import { LabelsBoxWithSearchType } from 'features/sport/components/sportBoxWithSearch/utils/utils';
import { useBlockScroll } from 'hooks/useBlockScroll';
import styles from './ScommesseFiltersMobile.module.scss';
import { ScommesseFiltersMobileFooter } from './scommesseFiltersMobileFooter';
import { ScommesseFiltersMobileHeader } from './scommesseFiltersMobileHeader';

export type ScommesseFiltersMobileProps = {
  text: string;
  isOpen: boolean;
  handleClose: React.Dispatch<React.SetStateAction<boolean>>;
  children?: React.ReactNode;
  hasSearch?: boolean;
  labels?: LabelsBoxWithSearchType;
  btnFooterLabel?: string;
};

export const ScommesseFiltersMobile = ({
  text,
  isOpen,
  handleClose,
  hasSearch,
  children,
  labels,
  btnFooterLabel,
}: ScommesseFiltersMobileProps) => {
  useBlockScroll(isOpen);

  return (
    <div className={`${styles.container} ${isOpen ? styles.visibile : styles.hidden}`}>
      <ScommesseFiltersMobileHeader label={text} handleClose={handleClose} hasSearch={hasSearch} labels={labels} />
      {children && (
        <div className={`${styles.wrapperMobileContent} ${btnFooterLabel ? styles.withFooter : ''}`}>{children}</div>
      )}

      {btnFooterLabel && <ScommesseFiltersMobileFooter btnLabel={btnFooterLabel} handleClose={handleClose} />}
    </div>
  );
};
